/**
 * The DropdownMessagesTemplate contains all the data needed to hydrate a dropdown messages component
 *
 * @typedef {Object}      defaultDropdownMessagesData
 *
 * @property {String}     extraClasses      - Extra classes if needed
 */

export const defaultDropdownMessagesData = {
  extraClasses: ''
}

export const DropdownMessagesTemplate = (d) => `
  ${d
    ? `
        ${d.map(message => `
          <div class="c-dropdown__message">
            <i class="m-icon m-icon--warning-circle"></i>
            <span>${message}</span>
          </div>
    `).join('')}
      `
    : ''}
`
